import environments from '../../config/environments';
/**
 * returns a redirect to element.
 */
export const redirectTo = (url) => {
    window.location = url;
    return null;
};

/**
 * Default redirect to Home.
 */
export const redirectToHome = () => {
    window.location = environments.cockpitUrl;
    return null;
};
